import React, { useCallback, useEffect } from 'react';
import TaskAndQueriesTemplate from 'components/Templates/TaskAndQueries';
import { Box } from '@mui/material';
import DeleteQuery from 'components/Organisms/Dialog/ActionList/TaskAndQueries/DeleteQuery';
import useController from 'hooks/useController';
import usePaginationAttributes from 'hooks/use-pagination-attributes';
import { hasPermission } from 'utils/permissions';
import { postListApiFormat, getListApiFormat } from 'utils/ApiPayloadFormat';
import { useSelector } from 'react-redux';
import useServices from '../common/useServices';
import useFilters from '../common/useFilters';
import useColumns from '../common/useColumns';
import useActionItems from '../common/useActionItems';

const ListMyActionableQueries = () => {
  const { pageSize } = usePaginationAttributes();
  const [columns] = useColumns();
  const services = useServices();
  const [controller, handlePageChange, handleSortChange, handleFiltersApply, handleFiltersClear] = useController();
  const authorities = useSelector((state) => state.session.user.authorities);
  const userHasCreatePermission = hasPermission(authorities, ['ROLE_BASE_PERMISSION_QUER_INDEX_CREATE_QUERY']);
  const [roleBasedMenu] = useActionItems(services);

  const filterService = useFilters(controller, services?.state?.listQueries?.data);

  const fetchQueriesList = useCallback(async () => {
    if (controller?.filters && Object.keys(controller?.filters).length > 0) {
      const formData = postListApiFormat(controller, pageSize);
      services.searchQueriesService(formData);
    } else {
      const queryData = getListApiFormat(controller, pageSize);
      services.listMyActionbaleQueriesService(queryData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [controller, pageSize]);

  useEffect(() => {
    fetchQueriesList();
  }, [fetchQueriesList, controller, pageSize]);

  const queriesListData = services?.state?.listQueries?.data?.data;
  return (
    <Box>
      <TaskAndQueriesTemplate
        pageHeading="My Actionable Queries"
        rows={queriesListData?.queryInstanceList}
        columns={columns}
        roleBasedMenu={roleBasedMenu}
        page={controller?.page || 0}
        sortDirection={controller.sort}
        sortBy={controller.sortBy}
        handleAddRequest={services.createQueryNavigationService}
        handleFilter={(data) => handleFiltersApply(data)}
        showFilter
        onSortChange={handleSortChange}
        onPageChange={handlePageChange}
        showPagination
        showRowSelector={false}
        isDynamic
        showActionList
        count={
          controller?.filters && Object.keys(controller?.filters).length > 0
            ? queriesListData?.totalCount
            : queriesListData?.queryInstanceCount
        }
        filterFields={filterService?.filterFields}
        handleFiltersClear={handleFiltersClear}
        actions={false}
        showAddButton={userHasCreatePermission}
        loading={services.state?.listQueries?.loading}
      />
      {services?.state?.open && (
        <DeleteQuery
          open={services?.state?.open}
          handleClose={() => services.handleOpenDialog(false)}
          handleCancel={() => services.handleOpenDialog(false)}
          handleDelete={() => {
            services?.deleteQueryService(services?.state?.queryDetails?.id);
          }}
          queryTitle={services?.state?.queryDetails?.title}
        />
      )}
    </Box>
  );
};

export default ListMyActionableQueries;
